<template>
  <div>
    <el-upload
      class="upload-btn"
      :action="action"
      :show-file-list="false"
      :on-preview="handlePreview"
      :on-success="successFile"
      :on-remove="handleRemove"
      :on-error="errorFile"
      :before-upload="beforeUpload"
      multiple
      :data="{ fileSuffixType: 'picture1' }"
      ref="upLoadFile"
      accept=".jpg,.png,.jpeg">
      <div class="el-upload--picture-card">
        <i class="el-icon-plus"></i>
      </div>
    </el-upload>
    <div class="upload-tip">
      <el-form :model="form" :rules="rules" ref="dataForm" class="demo-form-inline">
        <el-form-item prop="fileList">
          <div class="title">
            上传备件图片
          </div>
        </el-form-item>
      </el-form>
      <span class="tip">
        只能上传jpg/png文件，且不超过100M<br />
        最少上传1张，最多上传5张图片
      </span>
    </div>
    <div class="file-list">
      <div v-for="(img, index) in imgList" :key="img.id" class="imgContener">
        <img :src="img.url" alt="" class="img">
        <div class="del-btn" @click="clickDelBtn(index)">
          <i class="el-icon-close"></i>
        </div>
        <div class="main-btn ismain" v-show="img.isMain">
          备件主图
        </div>
        <div class="main-btn notmain" v-show="!img.isMain" @click="setImgMain(index)">
          <span class="circle"></span>设为主图
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'albumInfo', // 商品相册
  data () {
    return {
      form: {
        fileList: []
      },
      action: window.SITE_CONFIG['apiURL'] + '/front/fileupload/alioss/v2/upload',
      rules: {
        fileList: [
          { type: 'array', required: true, message: '请上传备件图片', trigger: 'change' }
        ]
      },
      subLoading: false
    }
  },
  methods: {
    handlePreview () {

    },
    handleRemove () {

    },
    clickDelBtn (index) {
      if (this.form.fileList[index].isMain) {
        if (this.form.fileList.length >= 1) {
          this.form.fileList[0].isMain = true
          this.form.fileList.splice(index, 1)
        }
      } else {
        this.form.fileList.splice(index, 1)
      }
      // let delIndex = 0
      // let index = someIndex
      // for (let i = 0; i < this.form.fileList.length; i++) {
      //   const ele = this.form.fileList[i]
      //   if (delIndex === index) {
      //     break;
      //   }
      //   if (ele.isDeleted) {
      //     index++
      //     delIndex++
      //   }
      // }
      // console.log(this.form.fileList);
      // this.$set(this.form.fileList[index], 'isDeleted', true)
      // if (this.form.fileList[index].isEdit) {
      //   // this.form.fileList[index].isDeleted = true
      //   this.$set(this.form.fileList[index], 'isMain', false)
      //   if (this.form.fileList.length) {
      //     let noMain = this.form.fileList.filter(item => {
      //       return !item.isDeleted
      //     }).every(item => {
      //       return !item.isMain
      //     })
      //     if (noMain) {
      //       debugger
      //       let nodeletedIndex = -1
      //       for (let i = 0; i < this.form.fileList.length; i++) {
      //         if (!this.form.fileList[i].isDeleted) {
      //           nodeletedIndex = i
      //           break;
      //         }
      //       }
      //       if (nodeletedIndex !== -1) {
      //         this.form.fileList[nodeletedIndex].isMain = true
      //       }
      //     }
      //   }
      //   return
      // }
      // this.removeFile(this.form.fileList[index])
      // debugger
      // if (this.form.fileList.length) {
      //   let noDeletedArr = this.form.fileList.filter(item => {
      //     return !item.isDeleted
      //   })
      //   let hasMain = noDeletedArr.findIndex(ai => {
      //     return ai.isMain
      //   })
      //   if (hasMain === -1) {
      //     // 找到第一个不是删除的设置为主图
      //     let fnoDelIndex = this.form.fileList.findIndex(item => {
      //       return !item.isDeleted
      //     })
      //     this.form.fileList[fnoDelIndex].isMain = true
      //   }
      // }
    },
    setImgMain (index) {
      // console.log(index);
      // console.log(this.form.fileList);
      this.form.fileList.map(item => {
        item.isMain = false
      })
      // // 找到已删除的索引index在全数组中的索引位置
      // let delIndex = 0
      // let allIndex = index
      // for (let i = 0; i < this.form.fileList.length; i++) {
      //   const ele = this.form.fileList[i]
      //   // if (delIndex >= index) {
      //   //   break;
      //   // }
      //   // allIndex++
      //   if (delIndex === index) {
      //     break;
      //   }
      //   if (ele.isDeleted) {
      //     allIndex++
      //     delIndex++
      //   }
      // }
      // 找到显示的所在索引
      this.form.fileList[index].isMain = true
    },
    // 上传失败
    errorFile () {
      this.subLoading = false
    },
    // 上传成功
    successFile (resolveponse, file, fileList) {
      if (resolveponse.code === 0) {
        this.form.fileList.push({
          uid: file.uid,
          ossId: resolveponse.data.aliOssId,
          ossName: file.name,
          name: file.name,
          isMain: false,
          url: resolveponse.data.url
          // uploadId: checkpoint.uploadId
        })
        // // 未删除的里是否有主图
        // let arr = this.form.fileList.filter(item => { return !item.isDeleted })
        // if (arr.length) {
        //   let hasMain = arr.findIndex(ai => {
        //     return ai.isMain
        //   })
        //   // 如果没有主图
        //   if (hasMain === -1) {
        //     // 设置第一个未删除的为主图
        //     let nodeletedIndex = -1
        //     for (let i = 0; i < this.form.fileList.length; i++) {
        //       if (!this.form.fileList[i].isDeleted) {
        //         nodeletedIndex = i
        //         break;
        //       }
        //     }
        //     if (nodeletedIndex !== -1) {
        //       this.form.fileList[nodeletedIndex].isMain = true
        //     }
        //   }
        // }
        if (this.form.fileList.length === 1) {
          this.form.fileList[0].isMain = true
        }
        this.subLoading = false
      } else {
        // console.log(this.$refs.upLoadFile.onRemove(file, fileList), file)
        // file.onError(file)
        this.$refs.upLoadFile.abort(file) // upload: el-upload的ref值；file:File类型，file文件本身
        fileList.splice(fileList.indexOf(file), 1) // fileList: 文件列表，钩子函数中的fileList
        this.removeFile(file, fileList)
        this.$message.error(resolveponse.msg || '上传失败')
        this.subLoading = false
      }
      this.$refs['dataForm'].clearValidate()
    },
    // 上传
    beforeUpload (file) {
      if (this.form.fileList.length >= 5) {
        this.$message.error('最多上传5张图片')
        return false
      }
      if (this.subLoading) {
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 100
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 100MB!')
        return false
      }
      let newName = file.name.slice(0, file.name.lastIndexOf('.'))
      let regx = /^[\u4E00-\u9FA5A-Za-z0-9]+$/
      if (regx.test(newName)) {
        let type = file.name.split('.')[1]
        let fileAcceptList = ['jpg', 'png', 'PNG', 'JPG']
        if (!fileAcceptList.includes(type)) {
          this.$message.error('请上传正确的文件类型')
          return false
        }
      } else {
        this.$message.warning('文件名只能由数字、英文字母、汉字组成，不能有空格 + 《 》等特殊符号')
        return false
      }
    },
    validateForm () {
      return new Promise((resolve, reject) => {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            resolve()
          } else {
            reject(new Error('商品相册填写不正确！'))
          }
        })
      })
    },
    getDataForm () {
      return this.form.fileList.filter(item => {
        return !item.isDeleted
      }).map(item => {
        return {
          aliOssId: item.ossId,
          type: item.isMain ? 6 : 5
        }
      })
    },
    setDataForm (data) {
      this.form.fileList = data.imageList.map(item => {
        return {
          ...item,
          ossId: item.aliOssId,
          isMain: item.type === '6',
          isEdit: true,
          isDelete: false
        }
      })
    },
    resetDataForm () {
      this.form.fileList = []
      // if (this.form.fileList.length) {
      //   this.form.fileList.forEach(item => {
      //     this.removeFile(item)
      //   })
      // }
      // this.$refs['dataForm'].resetFields()
    },
    // 删除文件
    removeFile (file) {
      if (this.subLoading) {
        return false
      }
      if (file.ossId) {
        let index = this.form.fileList.findIndex(item => {
          return item.uid === file.uid
        })
        if (index > -1) {
          this.$http.post(`${window.SITE_CONFIG['apiURL']}/help/fileupload/sys/deleteBatchAliOss`, [this.form.fileList[index].ossId])
            .then(item => {
              this.form.fileList.splice(index, 1)
            })
            .catch(() => {
            })
        }
      }
    }
  },
  computed: {
    imgList () {
      return this.form.fileList
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-btn {
  display: inline-block;
}
.upload-tip {
  display: inline-block;
  vertical-align: bottom;
  margin-left: 20px;
  .title {
    font-size: 14px;
    color: #333;
  }
  .tip {
    font-size: 12px;
    color: #606266;
  }
}
.file-list {
  margin-top: 20px;
  .imgContener {
    width: 148px;
    height: 148px;
    border-radius: 4px;
    margin: 6px;
    position: relative;
    display: inline-block;
    .img {
      width: 148px;
      height: 148px;
      border-radius: 4px;
    }
    .del-btn {
      position: absolute;
      cursor: pointer;
      top: 0;
      right: 0;
      width: 0;
      height: 0;
      border-top: 18px rgba($color: #ccc, $alpha: 0.4) solid;
      border-right: 18px rgba($color: #ccc, $alpha: 0.4) solid;
      border-left: 18px rgba($color: #000000, $alpha: 0) solid;
      border-bottom: 18px rgba($color: #000000, $alpha: 0) solid;
      .el-icon-close {
        position: absolute;
        top: -14px;

      }
    }
    .main-btn {
      position: absolute;
      cursor: pointer;
      color: #fff;
      text-align: center;
      bottom: 0;
      width: 100%;
      height: 32px;
      line-height: 32px;
      border-radius: 0 0 4px 4px;
    }
    .ismain {
      background: rgba($color: #0064c0, $alpha: 0.5);
    }
    .notmain {
      background: rgba($color: #000000, $alpha: 0.5);
    }
    .circle {
      margin-right: 6px;
      display: inline-block;
      vertical-align: middle;
      width: 14px;
      height: 14px;
      background: #fff;
      border-radius: 7px;
    }
  }
}
</style>
